export default __webpack_public_path__ + "static/media/walletConnect-new.5dd177b1.svg";